import gql from 'graphql-tag';

const MENU_FIELDS = gql`
  fragment MenuFields on DisplayMenu {
    id
    name
    type
    brandId
    categoryId
    collectionId
    tagId
    sortOrder
    brand {
      tnc
      images {
        url(size: "1920x350")
        mobileUrl(size: "768x730")
        alt
      }
    }
  }
`;

export const DISPLAY_MENUS = gql`
  ${MENU_FIELDS}
  query displayMenus($id: ID!, $isMobile: Boolean!) {
    display(id: $id) {
      id
      name
      image(size: 1800) @skip(if: $isMobile) {
        url
        alt
      }
      imageMobile(size: 1200) @include(if: $isMobile) {
        url
        alt
      }
      menus {
        ...MenuFields
        hasAllSubmenu
        children {
          ...MenuFields
        }
      }
    }
  }
`;
